'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  PE_FUND: 'PE Fund',
  VC_FUND: 'VC Fund',
  HEDGE_FUND: 'Hedge Fund',
  FUND_OF_FUND: 'Fund of Funds',
  INFRASTRUCTURE_FUND: 'Infrastructure Fund',
  REAL_ESTATE_FUND: 'Real Estate Fund',
  NATURAL_FUND: 'Natural Resources Fund',
  CREDIT_FUND: 'Credit Fund',
  OTHER: 'Others'
});